import classNames from 'classnames';
import { memo } from 'react';

import { SearchIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

export type DesignPreviewSearchFieldProps = {
  /** Dark surface scheme for the field; defaults to the original light scheme. */
  isDark?: boolean;
  /** Softens the field background when the header bar overlays a cover image (immersive cover). */
  isTranslucent?: boolean;
};

/** The faux search box shown on the right side of the preview header bar. */
export const DesignPreviewSearchField = memo(
  ({ isDark = false, isTranslucent = false }: DesignPreviewSearchFieldProps) => (
    <div
      className={cn(
        // Fixed 22px height + self-center so the faux field never stretches with the header bar.
        'flex h-[22px] w-[114px] max-w-[34%] shrink-0 items-center gap-[3px] self-center rounded-4 border px-1.5',
        isDark
          ? 'ads:border-ads-gray-9 border-gray-9 ads:bg-ads-gray-11 bg-gray-11'
          : 'ads:border-ads-gray-5 border-gray-5 ads:bg-ads-gray-1 bg-gray-1',
        isTranslucent && isDark ? 'ads:bg-ads-gray-11/80 bg-gray-11/80' : null,
        isTranslucent && !isDark ? 'ads:bg-ads-gray-1/80 bg-gray-1/80' : null,
      )}
    >
      <SearchIcon
        className={cn('shrink-0', isDark ? 'ads:text-ads-gray-7 text-gray-7' : 'ads:text-ads-gray-10 text-gray-10')}
        size="xs"
      />
      {/* Keep the arbitrary font-size OUT of cn(): tailwind-merge can't tell `text-[7px]` is a
        font-size vs a text-color and strips it when merged alongside `text-gray-*`. */}
      <span
        className={classNames(
          'min-w-0 flex-1 truncate text-[7px] leading-[143%]',
          isDark ? 'ads:text-ads-gray-6 text-gray-6' : 'ads:text-ads-gray-8 text-gray-8',
        )}
      >
        Search
      </span>
    </div>
  ),
);

DesignPreviewSearchField.displayName = 'DesignPreviewSearchField';
